module.exports = __webpack_public_path__ + "img/ji.e84e701f.jpg";